import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
    {
        q: "Entro quanto tempo si può impugnare un licenziamento illegittimo?",
        a: "Il licenziamento va impugnato entro 60 giorni dalla comunicazione, con qualsiasi atto scritto — anche stragiudiziale — che manifesti la volontà di contestarlo. Successivamente, entro 180 giorni, occorre depositare il ricorso in Tribunale o promuovere il tentativo di conciliazione/arbitrato. È fondamentale rivolgersi tempestivamente a un avvocato giuslavorista per non perdere il diritto alla tutela.",
    },
    {
        q: "Quando un licenziamento è illegittimo?",
        a: "Un licenziamento è illegittimo quando manca di giusta causa o giustificato motivo (oggettivo o soggettivo), quando viola la procedura disciplinare (artt. 7 St. Lav.), quando è discriminatorio, ritorsivo, intimato in periodo di tutela (es. maternità) o per ragioni non veritiere. Le conseguenze vanno dalla reintegrazione nel posto di lavoro al risarcimento del danno, a seconda della tipologia di vizio e del regime applicabile.",
    },
    {
        q: "Cos'è il mobbing sul lavoro e come si dimostra?",
        a: "Il mobbing è una condotta sistematica, prolungata nel tempo e oggettivamente vessatoria del datore di lavoro o di colleghi, finalizzata a emarginare o danneggiare il lavoratore. Si dimostra attraverso testimonianze, email, messaggi, ordini di servizio, demansionamento documentato, certificazioni mediche (disturbo dell'adattamento, ansia, depressione reattiva) e consulenze tecniche psichiatriche. Il risarcimento può riguardare danno biologico, morale ed esistenziale.",
    },
    {
        q: "Quanto costa una prima consulenza dall'Avv. Candido?",
        a: "Il primo incontro conoscitivo, finalizzato all'esposizione e alla valutazione del caso, è sempre gratuito. Lo Studio fornisce un parere preliminare sulla fondatezza della pretesa e sulle strategie percorribili, con preventivo trasparente prima di qualsiasi attività professionale.",
    },
    {
        q: "Lo Studio assiste solo lavoratori o anche aziende?",
        a: "Lo Studio assiste entrambe le parti: lavoratori, dirigenti e quadri da un lato, aziende e datori di lavoro dall'altro (anche in outsourcing su tutto il diritto del lavoro). L'esperienza maturata su entrambi i fronti consente un approccio strategico più efficace nelle trattative e nelle conciliazioni stragiudiziali.",
    },
    {
        q: "Quali sono le sedi dello Studio?",
        a: "La sede principale è a Piacenza in Corso Vittorio Emanuele II, 142/D (tel. 0523 468737). Lo Studio riceve su appuntamento anche a Milano e a Lecce, oltre che in modalità remota. Opera in tutta Italia.",
    },
];

export default function FaqSection() {
    const [open, setOpen] = useState(0);

    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="py-24 lg:py-36 bg-white relative overflow-hidden"
        >
            <div className="max-w-5xl mx-auto px-6 lg:px-10">
                <div className="max-w-3xl mb-16">
                    <div className="flex items-center gap-4 mb-6">
                        <span className="gold-rule" />
                        <span className="label-eyebrow">Domande Frequenti</span>
                    </div>
                    <h2 className="font-serif text-navy text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                        Le risposte alle <span className="italic text-gold-deep">domande</span> più comuni.
                    </h2>
                    <p className="mt-5 text-slate-600 text-base md:text-lg leading-relaxed">
                        Dubbi frequenti sul diritto del lavoro, con risposte sintetiche dello Studio. Per casi concreti, contattaci per una prima consulenza gratuita.
                    </p>
                </div>

                <div className="divide-y divide-slate-200 border-y border-slate-200" data-testid="faq-list">
                    {FAQS.map((item, idx) => {
                        const isOpen = open === idx;
                        return (
                            <div key={idx} data-testid={`faq-item-${idx}`}>
                                <button
                                    onClick={() => setOpen(isOpen ? -1 : idx)}
                                    aria-expanded={isOpen}
                                    aria-controls={`faq-panel-${idx}`}
                                    data-testid={`faq-toggle-${idx}`}
                                    className="w-full py-7 lg:py-8 flex items-start justify-between gap-6 text-left group"
                                >
                                    <h3 className="font-serif text-xl md:text-2xl text-navy group-hover:text-gold-deep transition-colors leading-tight">
                                        {item.q}
                                    </h3>
                                    <span className="flex-shrink-0 w-10 h-10 border border-navy/30 group-hover:border-gold group-hover:bg-gold flex items-center justify-center transition-all duration-300">
                                        {isOpen ? <Minus size={18} className="text-navy" /> : <Plus size={18} className="text-navy" />}
                                    </span>
                                </button>
                                <div
                                    id={`faq-panel-${idx}`}
                                    role="region"
                                    className={`grid transition-all duration-500 ease-out ${isOpen ? "grid-rows-[1fr] opacity-100 pb-8" : "grid-rows-[0fr] opacity-0"}`}
                                >
                                    <div className="overflow-hidden">
                                        <p className="text-slate-600 text-base md:text-lg leading-relaxed pr-16">
                                            {item.a}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
